import paths from './paths'

const PageTerms = () => import(/* webpackMode: "lazy", webpackChunkName: "page-order-details" */ './pages/PageTerms')
const PageNemBillet = () => import(/* webpackMode: "lazy", webpackChunkName: "page-nem-billet" */ './pages/PageNemBillet')
const PageLetbanePayment = () => import(/* webpackMode: "lazy", webpackChunkName: "page-payment-home" */ './pages/PageLetbanePayment')
const PagePaymentComplete = () => import(/* webpackMode: "lazy", webpackChunkName: "page-payment-complete" */ './pages/PagePaymentComplete')
const PagePaymentStatus = () => import(/* webpackMode: "lazy", webpackChunkName: "page-payment-status" */ './pages/PagePaymentStatus')
const PagePaymentReceipt = () => import(/* webpackMode: "lazy", webpackChunkName: "page-payment-receipt" */ './pages/PagePaymentReceipt')
const PageLetbaneError = () => import(/* webpackMode: "lazy", webpackChunkName: "page-letbane-error" */ './pages/PageLetbaneError')

const routes = [
	{
		path: paths.terms,
		name: 'PageTerms',
		component: PageTerms
	},
	{
		path: paths.nembillet,
		name: 'PageNemBillet',
		component: PageNemBillet
	},
	{
		path: paths.letbanehome,
		name: 'PageLetbanePayment',
		component: PageLetbanePayment
	},
	{
		path: paths.paymentcomplete,
		name: 'PagePaymentComplete',
		component: PagePaymentComplete
	},
	{
		path: paths.paymentstatus,
		name: 'PagePaymentStatus',
		component: PagePaymentStatus
	},
	{
		path: paths.paymentreceipt,
		name: 'PagePaymentReceipt',
		component: PagePaymentReceipt
	},
	{
		path: paths.letbaneerror,
		name: 'PageLetbaneError',
		component: PageLetbaneError
	}
]

export default routes
